import { createStore } from 'redux';
import { devToolsEnhancer } from 'redux-devtools-extension';

import combinedReducers from './reducers';

const store = createStore(combinedReducers, devToolsEnhancer());

export default store;
